import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LogsTable from './LogsTable';
import FullPageLoader from 'components/common/FullPageLoader';
import { fetchMainAccountAppointmentLogs } from 'slices/mainAccount/mainAccountAppointmentSlice';
import { fetchMainAccountAppointmentView } from 'slices/mainAccount/mainAccountAppointmentSlice';
import ViewTable from 'views/appointment/view/ViewTable';

const AppointmentView = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [item, setItem] = React.useState({});
    const [loading, setLoading] = React.useState(false)
    const [logs, setLogs] = React.useState([]);

    const callViewApi = async () => {
        const callBack = (success, message, data) => {
            setLoading(false);
            if (success) {
                setItem(data)
                console.log(data)
            }
            else {
                console.log(message)
            }
        }

        dispatch(fetchMainAccountAppointmentView(id, callBack))
    };

    const fetchLogs = async () => {
        const callBack = (success, message, data) => {
            if (success) {
                setLogs(data)
                console.log(data)
            }
            else {
                console.log(message)
            }
            // setLogs()
        }
        dispatch(fetchMainAccountAppointmentLogs(id, callBack))
    }

    React.useEffect(() => {
        setLoading(true)
        callViewApi();
        fetchLogs();

    }, [id]);


    return (
        <div className="content" style={{}}>
            {loading && <FullPageLoader  />}
            <div className="card_table view_table_custom">

                <div className="row_main_head">
                    <h2 className={`main_heading`}>View Job </h2>
                    <div className='text-transform-capitalize main_heading' >
                        Status : {item?.status}
                    </div>
                </div>

                <div className="row_table_head">
                    <div className="result-foot">
                        <span>Job ID : {item?.appid}</span>
                    </div>
                </div>

                <ViewTable item={item} />
            </div>

            <div className="card_table p-4">
                <div className="row_main_head mb-3">
                    <h2 className={`main_heading`}>Job Logs</h2>
                </div>
                <LogsTable logs={logs} />
            </div>
        </div>
    )
}





export default AppointmentView